import omit from "lodash/omit";
import qs from "qs";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";

import { Filter, getFilterKeys } from "~/features/filter";

import { combinationRulesFilterFields } from "./fields";

const CombinationRulesFilter = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const fields = useMemo(() => combinationRulesFilterFields(t), [t]);

  const handleReset = () => {
    const params = location.search ? qs.parse(location.search.slice(1)) : {};
    const rest = omit(params, [...getFilterKeys(fields), "page", "status"]);
    history.replace({
      search: qs.stringify(rest),
    });
  };

  return (
    <Filter.Root fields={fields} alwaysShow columns={3} onReset={handleReset} />
  );
};

export default CombinationRulesFilter;
